import script from "./TagEditorFields.vue?vue&type=script&setup=true&lang=js"
export * from "./TagEditorFields.vue?vue&type=script&setup=true&lang=js"

import "./TagEditorFields.vue?vue&type=style&index=0&id=6b2cabaa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2cabaa"]])

export default __exports__